const REACT_PUBLIC_API_URL = process.env.REACT_PUBLIC_API_URL || "https://api.flashsearch.in";

export { REACT_PUBLIC_API_URL };
